export default "__VITE_ASSET__DqWzzizQ__"